import firebase from 'firebase/app'
import 'firebase/database'
import { snapshotToArray } from '../../utilities/firebase.utilities'
import { sortBy } from '../../utilities/array.utilities';

export default {
  namespaced: true,
  state: {
    project: {},
    users: []
  },
  getters: {

  },
  actions: {
    fetchProject({commit, state}, id) {
      return new Promise((resolve) => {
        const query = firebase.database().ref(`projects/${id}`)
        query.on('value', (res) => {
          const project = res.val()
          project.id = id
          commit('setProject', project)
          resolve(state.project)
        })
      })
    },
    fetchUsers({commit}, id) {
      return new Promise((resolve) => {
        const query = firebase.database().ref('users').orderByChild('projectId').equalTo(id)
        query.on('value', (res) => {
          let users = snapshotToArray(res)
          users = sortBy(users, 'loginId')
          commit('setUsers', users)
          resolve()
        })
      })
    },
    addUser(context, user) {
      firebase.database().ref('users').push(user)
    },
    updateUser(context, user) {
      firebase.database().ref(`users/${user.key}`).update(user)
    },
    deleteUser(context, user) {
      firebase.database().ref(`users/${user.key}`).remove()
    }
  },
  mutations: {
    setProject(state, project) {
      state.project = project
    },
    setUsers(state, users) {
      state.users = users
    },
    updateUser(state, user) {
      state.users[user.id] = user
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/projects.js